let vern = null
if (getQueryVariable('system') == 'ios') {
  if (window && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.version) {
    console.log(typeof (window.webkit.messageHandlers.version.postMessage), 'version')
    if (typeof (window.webkit.messageHandlers.version.postMessage) == "function") {
      window.webkit.messageHandlers.version.postMessage(['获取版本号'])
    }

  }
}
function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) { return pair[1]; }
  }
  return (false);
}
function showVersion(version) {
  console.log(version)
  vern = version
}

export default vern;